<template>
    <svg class="icon-plus fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
        <g transform="translate(12394 17046)">
            <rect width="15" height="3" transform="translate(-12394 -17040)" />
            <rect width="15" height="3" transform="translate(-12385 -17046) rotate(90)" />
        </g>
    </svg>
</template>
